export const abbreviations = {
    Genesis: "Gen.",
    Exodus: "Exo.",
    Leviticus: "Lev.",
    Numbers: "Num.",
    Deuteronomy: "Deut.",
    Joshua: "Josh.",
    Judges: "Judg.",
    Samuel: "Sam.",
    Chronicles: "Chron.",
    Ezra: "Ezra",
    Nehemiah: "Neh.",
    Esther: "Est.",
    Psalms: "Psa.",
    Proverbs: "Prov.",
    Ecclesiastes: "Eccles.",
    "Song of Solomon": "Song",
    Isaiah: "Isa.",
    Jeremiah: "Jer.",
    Lamentations: "Lam.",
    Ezekiel: "Ezek.",
    Daniel: "Dan.",
    Hosea: "Hos.",
    Joel: "Joel",
    Micah: "Mic.",
    Nahum: "Nah.",
    Habakkuk: "Hab.",
    Zephaniah: "Zeph.",
    Haggai: "Hag.",
    Zechariah: "Zech.",
    Malachi: "Mal.",
    Matthew: "Matt.",
    Romans: "Rom.",
    Corinthians: "Cor.",
    Galatians: "Gal.",
    Ephesians: "Eph.",
    Philippians: "Phil.",
    Colossians: "Col.",
    Thessalonians: "Thess.",
    Timothy: "Tim.",
    Philemon: "Philem.",
    Hebrews: "Heb.",
    Peter: "Pet.",
    Revelation: "Rev.",
};
